import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../product_audience_header/product_audience_header.scss';
import { FaSignOutAlt } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { loggedIn, loggedOut } from '../../../sellers_module/store/slice/authSlice';
import { audienceContactUs, tokenverfy } from '../../../sellers_module/services/seller/api';
import { ReactComponent as IssueIcon } from '../../../assets/issue.svg';
import { toast, ToastContainer } from 'react-toastify';

const ProductAudienceHeader = () => {
    const [selectedValue, setSelectedValue] = useState<string>('');
    const firstName = localStorage.getItem('first_name') ?? '';
    const email = localStorage.getItem('email') ?? '';
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false); // State for popup visibility
    const [issueType, setIssueType] = useState(''); // Dropdown value
    const [issueDescription, setIssueDescription] = useState(''); // Textarea value
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [selectedAudienceID, setSelectedAudienceID] = useState(localStorage.getItem('selectedAudienceID'));
    const [issueTypeError, setIssueTypeError] = useState('');
    const [issueDescriptionError, setIssueDescriptionError] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [contactNumberError, setContactNumberError] = useState('');
    const toggleIsUserMenuOpen = useCallback(() => setIsUserMenuOpen((prev) => !prev), []);
    const dispatch = useDispatch();
    const menuRef = useRef<HTMLDivElement>(null);
    const userInfoRef = useRef<HTMLDivElement>(null);

    const handleLogout = () => {
        localStorage.clear();
        dispatch(loggedOut());
        window.location.href = '/shiprocket_audience';
    };

    const handleClickOutside = (e: MouseEvent) => {
        if (
            menuRef.current && !menuRef.current.contains(e.target as Node) &&
            userInfoRef.current && !userInfoRef.current.contains(e.target as Node)
        ) {
            setIsUserMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const handleSubmit = async () => {
        let valid = true;

        // Reset errors
        setIssueTypeError('');
        setIssueDescriptionError('');
        setContactNumberError('');

        // Validate issueType
        if (!issueType) {
            setIssueTypeError('Please select an issue type');
            valid = false;
        }

        // Validate contact number
        if (!contactNumber.trim()) {
            setContactNumberError('Please provide a contact number');
            valid = false;
        } else if (!/^\d{10}$/.test(contactNumber.trim())) {
            setContactNumberError('Please enter a valid 10-digit contact number');
            valid = false;
        }

        // Validate issueDescription
        if (!issueDescription.trim()) {
            setIssueDescriptionError('Please provide a description');
            valid = false;
        }

        if (!valid) {
            return;
        }

        const data = {
            subject: issueType,
            message_body: issueDescription,
            contact_number: contactNumber // Remove country code
        }

        try {
            const res = await audienceContactUs(data);
            if (res.data.message) {
                toast.success(res.data.message);
            } else {
                toast.error("Something went wrong..");
            }
        }
        catch (error: any) {
            console.log(error)
        }

        closePopup();
    };

    const openPopup = () => {
        console.log('Opening popup');
        setIsPopupOpen(true);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setIsPopupVisible(false);
    };

    const verifyToken = async () => {
        const storedToken = localStorage.getItem('satellizer_token');
        const selectedAudienceID = localStorage.getItem('selectedAudienceID');

        // Proceed if there's a stored token
        if (storedToken) {
            const data = {
                token: storedToken,
                validate_token_request: 1,
            };

            try {
                const response = await tokenverfy(data);
                console.log('Token verification response:', response.data);

                // Extract account data from the response
                const result = response.data.result || [];
                if (result.length === 0) {
                    console.warn('No accounts found in the response.');
                }

                // Store user and account data in Redux
                dispatch(
                    loggedIn({
                        userData: {
                            first_name: response.data.userData.first_name,
                            last_name: response.data.userData.last_name,
                            company_name: response.data.userData.company_name,
                            email: response.data.userData.email,
                        },
                        model: {
                            company_id: response.data.model.company_id,
                        },
                        result: result, // This already contains the array of accounts
                        token: storedToken, // Use the stored token
                    })
                );

                // Generate dropdown options
                const accountOptions = result.map((account) => {
                    const cleanedAccountId = account.account_id.replace(/^act_/, ''); // Remove 'act_' prefix
                    const accountName = account.account_name || "Unknown Account"; // Default if no name
                    return {
                        value: cleanedAccountId,
                        label: `Account id - ${cleanedAccountId} (${accountName})`,
                    };
                });

                console.log('Updated Dropdown Options:', accountOptions);

                // Get the selected audience ID (cleaned)
                const firstAccountId = result.length > 0 ? result[0].account_id.replace(/^act_/, '') : '';
                const selectedValue = selectedAudienceID || firstAccountId;
                localStorage.setItem('selectedAudienceID', firstAccountId);
                setSelectedAudienceID(firstAccountId)// Save as a cleaned string

                // Update selected value state
                setSelectedValue(selectedValue);
                setSelectedAudienceID(firstAccountId)
                console.log('Selected Value:', selectedValue);

            } catch (error: any) {
                console.error('Error during token verification:', error.message);
                localStorage.clear();
                dispatch(loggedOut());
            }
        } else {
            console.warn('No stored token found.');
        }
    };

    // Start interval for token verification if selectedAudienceID exists
    useEffect(() => {
        if (selectedAudienceID) {
            const intervalId = setInterval(() => {
                verifyToken(); // Call verifyToken every 30 seconds
            }, 30000);

            // Clean up the interval when the component unmounts or selectedAudienceID changes
            return () => clearInterval(intervalId);
        }
    }, [selectedAudienceID, selectedValue]);

    // Add handler for contact number input
    const handleContactNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow digits
        if (value === '' || /^\d+$/.test(value)) {
            setContactNumber(value);
        }
    };

    const user = {
        firstName,
        email,
        avatar: 'https://iili.io/JETT4gs.png',
    };
    return (
        <>
            <ToastContainer style={{ paddingTop: "50px" }} />
            <div className="p-audienceHeader-bg">
                <div className="left-content">
                    <a href="/shiprocket_audience" rel="noopener noreferrer">
                        <img
                            style={{ width: '400px', padding: '50px' }}
                            src="https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727165047_file.png"
                            alt="Shiprocket Icon"
                        />
                    </a>
                </div>
                <div className="right-content">
                    <div className="report-button">
                        <div style={{ display: "flex", gap: "20px", alignItems: "center" }} onClick={openPopup}>
                            <IssueIcon style={{ stroke: "white", width: "30px" }} />
                            <button>Report an issue</button>
                        </div>

                    </div>
                    <span className="switch-account-label">Switch Account?</span>
                    <div className="user-menu">
                        <div className="user-info" onClick={toggleIsUserMenuOpen} ref={userInfoRef}>
                            <img src={user.avatar} alt={`${user.firstName}`} className="avatar" />
                        </div>
                        {isUserMenuOpen && (
                            <div className="menu-dropdown" ref={menuRef}>
                                <div className="user-details">
                                    <p className="user-name">{user.firstName}</p>
                                </div>
                                <ul>
                                    <li onClick={handleLogout}>
                                        <FaSignOutAlt className="menu-icon" />
                                        Logout
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                {(
                    <div className={`popup-overlay ${isPopupVisible ? 'visible' : ''}`}>
                        <div className="popup-content">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                {/* Close Icon */}
                                <div
                                    style={{
                                        alignSelf: 'flex-end',
                                        textAlign: 'right',
                                        cursor: 'pointer',
                                        fontSize: '20px',
                                        color: '#6a6a94', // Icon color
                                        marginBottom: '10px',
                                    }}
                                    onClick={closePopup} // Close popup when clicked
                                    title="Close"
                                >
                                    ✖
                                </div>
                                <div style={{ textAlign: "center" }} onClick={openPopup}>
                                    <IssueIcon style={{ marginLeft: "20px", fill: "#6a6a94" }} />
                                    <label style={{ fontFamily: "sfprobold", fontSize: "14px" }}>{"Raise an issue"}</label>
                                </div>

                                {/* Dropdown for selecting issue type */}
                                <select
                                    id="issue-type"
                                    value={issueType}
                                    onChange={(e) => setIssueType(e.target.value)}
                                    style={{
                                        marginTop: "20px",
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: issueTypeError ? '1px solid red' : '1px solid #6a6a94', // Red border if error
                                        marginBottom: '15px',
                                    }}>
                                    <option style={{ color: "#6a6a94" }} value="">{"Select the issue you're facing"}</option>
                                    <option value="Payment done but Audience not showing">{"Payment done but Audience not showing"}</option>
                                    <option value="Audience shared but showing as pending">{"Audience shared but showing as pending"}</option>
                                    <option value="Not able to make payment">{"Not able to make payment"}</option>
                                    <option value="other">Other</option>
                                </select>

                                {issueTypeError && (
                                    <div style={{ color: 'red', fontSize: '12px', marginBottom: '10px' }}>
                                        {issueTypeError}
                                    </div>
                                )}

                                <input
                                    type="tel"
                                    id="contact-number"
                                    value={contactNumber}
                                    onChange={handleContactNumberChange}
                                    placeholder="Contact Number"
                                    maxLength={10}
                                    onKeyPress={(e) => {
                                        // Prevent non-numeric keys
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: contactNumberError ? '1px solid red' : '1px solid #6a6a94',
                                        marginBottom: '15px',
                                    }}
                                />

                                {contactNumberError && (
                                    <div style={{ color: 'red', fontSize: '12px', marginBottom: '10px' }}>
                                        {contactNumberError}
                                    </div>
                                )}

                                <textarea
                                    id="issue-description"
                                    value={issueDescription}
                                    onChange={(e) => setIssueDescription(e.target.value)}
                                    placeholder="Additional Remarks"
                                    rows={4}
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: issueDescriptionError ? '1px solid red' : '1px solid #6a6a94',
                                        marginBottom: '15px',
                                    }}
                                />

                                {issueDescriptionError && (
                                    <div style={{ color: 'red', fontSize: '12px', marginBottom: '10px' }}>
                                        {issueDescriptionError}
                                    </div>
                                )}

                                {/* Buttons for Submit and Cancel */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    <button
                                        onClick={closePopup} // Close the popup on cancel
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: 'white',
                                            color: '#6a6a94',
                                            border: '1px solid #6a6a94',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#6a6a94', // Submit button color
                                            color: 'white',
                                            border: '1px solid #6a6a94',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}



            </div>
        </>
    );
};

export default ProductAudienceHeader;
